<template>
  <v-card>
    <v-expansion-panels multiple>
      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="info">
            <v-icon>
              info
            </v-icon>
            {{ $t('Общая информация') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="text-left px-4">
            <text-view
                :display="lot.lotDescription"
                multiline
                :label="$t('Предмет договора (наименование)')" />
            <text-view
                :display="lot.lotNumber"
                multiline
                md="6"
                :label="$t('№ торговой процедуры')"
                :to="isAdmin
                  ? `${urlRootPath}/lot/${lot.lotType}/${lot.lotId}`
                  : null" />
            <text-view
                :display="lotStatus"
                multiline
                md="6"
                :label="$t('Статус торговой процедуры')" />
            <text-view
                :display="$t(LOT_TYPE_ENUM[lot.lotType])"
                multiline
                md="6"
                :label="$t('Тип торговой процедуры')" />
            <text-view
                :display="$t(PREMIUM_TYPE_ENUM[lot.premiumType])"
                multiline
                md="6"
                :label="$t('Способ расчета цены')" />
            <text-view
                v-if="lot.premiumType === PREMIUM_TYPES.FIX"
                :display="lot.currency"
                multiline
                md="6"
                :label="$t('Валюта контракта')" />
            <text-view
                :display="lot.organizer
                  ? lot.organizer.organizationName
                  : null"
                multiline
                md="6"
                :label="$t('Организатор')" />
            <date-view
                :display="lot.publicationDate"
                multiline
                md="6"
                :label="$t('Дата публикации')"
                date-format="DD.MM.YYYY" />
            <text-view
                :display="$t('Углеводороды')"
                multiline
                md="6"
                :label="$t('Торговая секция')" />
            <text-view
                v-if="lot.startCost"
                multiline
                md="6"
                :label="$t('Стоимость лота, ') + $t(VAT_TEXT)"
                :display="`${lot.startCost} ${$t('руб.')}`" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="showIncoterms" v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="incoterms">
            <v-icon>
              mdi-routes
            </v-icon>
            {{ $t('Условия и базис поставки Incoterms') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <text-view
                icon="person"
                :display="lot.incotermName"
                multiline
                md="6"
                :label="$t('Условия поставки')" />
            <v-col
                cols="12"
                :md="$vuetify.breakpoint.lgAndDown ? 12 : 6">
              <delivery-basises
                  v-if="lot.lotDeliveryBasises && lot.lotDeliveryBasises.length > 0"
                  :value="lot.lotDeliveryBasises"
                  :incoterm-id="lot.incotermId"
                  readonly
                  viewonly
                  :only-route="!isAdmin && !isLotOwner(lot)" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="!isParticipant" v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="contact_mail">
            <v-icon>
              contact_mail
            </v-icon>
            {{ $t('Контактная информация') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="text-left px-4">
            <text-view
                icon="person"
                :display="lot.contactPerson"
                multiline
                md="6"
                :label="$t('Контактное лицо')" />
            <text-view
                icon="alternate_email"
                :display="lot.contactEmail"
                multiline
                md="6"
                :label="$t('Электронный адрес')" />
            <text-view
                icon="settings_phone"
                :display="lot.contactPhone"
                multiline
                md="6"
                :label="$t('Контактный телефон')" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="positions">
        <v-expansion-panel-header>
          <div id="storage">
            <v-icon>
              storage
            </v-icon>
            {{ $t('Состав торговой процедуры') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager class="py-2">
          <v-card>
            <slot name="positions" />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="sessions">
        <v-expansion-panel-header>
          <div id="gavel">
            <v-icon>
              gavel
            </v-icon>
            {{ $t('Торговые сессии') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-card>
            <slot name="sessions" />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="attachments">
        <v-expansion-panel-header>
          <div id="attach_file">
            <v-icon>
              attach_file
            </v-icon>
            {{ $t('Документы по торговой процедуре') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <!-- <v-card> -->
          <slot name="attachments" />
          <!-- </v-card> -->
        </v-expansion-panel-content>
      </v-expansion-panel>

      <slot name="additional" />
    </v-expansion-panels>

    <slot name="footer" />

  </v-card>
</template>

<script>

  import TextView from '@/components/reused/ui/TextView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import DeliveryBasises from '@/components/reused/ui/DeliveryBasises.vue'
  import { DICTIONARY_TYPES, LOT_STATUSES, VAT_TEXT, PREMIUM_TYPES } from '@/constants/business'
  import {
    LOT_TYPE_ENUM,
    LOT_STATUS_TYPE_ENUM,
    TRADE_RESULT_TYPE_ENUM,
    PREMIUM_TYPE_ENUM
  } from '@/constants/enums'

  export default {
    components: {
      TextView,
      DateView,
      DeliveryBasises
    },
    props: {
      lot: {
        type: Object,
        required: true
      },
      positions: {
        type: Boolean,
        default: false
      },
      sessions: {
        type: Boolean,
        default: false
      },
      attachments: {
        type: Boolean,
        default: false
      },
      showIncoterms: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        LOT_TYPE_ENUM,
        DICTIONARY_TYPES,
        LOT_STATUS_TYPE_ENUM,
        TRADE_RESULT_TYPE_ENUM,
        LOT_STATUSES,
        VAT_TEXT,
        PREMIUM_TYPE_ENUM,
        PREMIUM_TYPES
      }
    },
    computed: {
      lotStatus: function () {
        if (this.lot.lotStatus === LOT_STATUSES.FINISHED) {
          return `${this.$t(LOT_STATUS_TYPE_ENUM[this.lot.lotStatus])} (${this.$t(TRADE_RESULT_TYPE_ENUM[this.lot.tradeResultType])})`
        } else {
          return this.$t(LOT_STATUS_TYPE_ENUM[this.lot.lotStatus])
        }
      }
    }
  }
</script>
